export default {
	SET_LANGUAGES: "SET_LANGUAGES",
	CREATE_LANGUAGE: "CREATE_LANGUAGE",
	SET_LOADING: "SET_LOADING",
	REMOVE_LANGUAGE: "REMOVE_LANGUAGE"
}